import * as React from 'react';
import {Helmet} from 'react-helmet';

import classnames from 'classnames';

import {headTitle} from 'shells/document/head-title';
import {MainContentContainer} from 'shells/layout/main-content-container';

import {PageWrapperContext} from './page-wrapper-context';

import styles from './page-container.module.css';

export const PAGE_CONTAINER_CONTENT_ID = 'page_container_content_id';

type Props = {
    title: string;
    promotionalBanner?: React.ReactNode;
    pageTitleBar?: React.ReactNode;
    controlBar?: React.ReactNode;
    noPadding?: boolean;
    whiteBackground?: boolean;
    darkBackground?: boolean;
    children: React.ReactNode;
    flashBanner?: React.ReactNode;
};

export function PageContainer(props: Props) {
    const contentStyles = classnames({
        [styles['page-content-wrapper']]: true,
        [styles['no-padding']]: props.noPadding,
    });

    return (
        // @ts-expect-error
        <PageWrapperContext.Provider value={{flashBanner: props.flashBanner}}>
            <Helmet>
                <title>{headTitle(props.title)}</title>
            </Helmet>
            <MainContentContainer
                whiteBackground={props.whiteBackground}
                darkBackground={props.darkBackground}
                preventInnerScroll={true}
            >
                {props.promotionalBanner}
                {props.pageTitleBar}
                {props.controlBar}
                <div id={PAGE_CONTAINER_CONTENT_ID} className={contentStyles}>
                    {props.children}
                </div>
            </MainContentContainer>
        </PageWrapperContext.Provider>
    );
}
